import React, { useState } from 'react'
import { CREATE, useClient } from '@peracto/client'
import { Link } from 'react-router-dom'

import { LoginFormContainer } from './styled'
import { useRecaptcha, withRecaptcha } from '../Recaptcha'

const ForgottenForm = ({ ...props }) => {
    const { client } = useClient()
    const { getRecaptchaHeaders } = useRecaptcha()

    const [message, setMessage] = useState('')
    const [formData, setFormData] = useState({
        email: '',
    })
    const [formErrors, setFormErrors] = useState({})

    const onSubmitResetPassword = async e => {
        e.preventDefault()
        const headers = await getRecaptchaHeaders('reset_password')
        dispatch('users/reset-password', { email: formData.email }, headers)
    }

    const onUpdateFields = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const dispatch = async (url, data, headers = {}) => {
        try {
            const response = await client(CREATE, url, { data }, headers)
            setFormErrors({})

            if (response.data.violations !== undefined) {
                let errors = {}
                response.data.violations.map(({ propertyPath, message }) => {
                    errors[propertyPath] = message
                })
                setFormErrors(errors)
                return
            }

            setMessage(
                response?.data?.message ||
                    'If you have an account, an email will be generated to reset your password.'
            )
        } catch (e) {
            console.log('Error', e)

            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                const errorMessages = {}
                e.error.body.violations.forEach(error => {
                    errorMessages[error.propertyPath] = error.message
                })
                setFormErrors(errorMessages)
            } else if (e?.error?.body['hydra:description']) {
                // Handle general error messages
                setMessage(e.error.body['hydra:description'])
            } else if (e?.error?.message) {
                setMessage(e.error.message)
            } else {
                setMessage('An unknown error occurred. Please try again later.')
            }
        }
    }

    return (
        <LoginFormContainer {...props}>
            <div>
                <h1 className="!mb-6">Forgotten your password</h1>
                {message !== '' ? (
                    <p className="mt-10 alert alert-info">{message}</p>
                ) : (
                    <p>
                        Enter your email address below and we'll send you instructions on how to
                        change your password.
                    </p>
                )}
                <form onSubmit={onSubmitResetPassword}>
                    <div className="form-group">
                        <input
                            className="form-control test-focus"
                            onChange={onUpdateFields}
                            placeholder="Enter your email address"
                            type="email"
                            name="email"
                            data-testid="email"
                        />
                        {formErrors.email && (
                            <p style={{ marginTop: '12px' }} className="alert alert-danger">
                                {formErrors.email}
                            </p>
                        )}
                    </div>
                    <div className="!flex !justify-between !items-center">
                        <button className="btn btn-primary" data-testid="reset">
                            Reset
                        </button>
                        <Link to="/login" className="btn btn-link" data-testid="sign-in">
                            Sign In
                        </Link>
                    </div>
                </form>
            </div>
        </LoginFormContainer>
    )
}

export default withRecaptcha(ForgottenForm)
